import { useState } from "react";
import { Box, Button, Stack, TextField } from "@mui/material";

interface Props {
  onSubmit: (text: string) => void | Promise<void>;
  onCancel: () => void;
  autoFocus?: boolean;
  placeholder?: string;
}

const MAX_LENGTH = 200;

export function CommentReplyComposer({
  onSubmit,
  onCancel,
  autoFocus = true,
  placeholder = "Reply…",
}: Props) {
  const [draft, setDraft] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const trimmed = draft.trim();
  const disabled = trimmed.length === 0 || submitting;

  const handleSubmit = async () => {
    if (disabled) return;
    setSubmitting(true);
    try {
      await onSubmit(trimmed);
      setDraft("");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Stack spacing={1} sx={{ mt: 0.5 }}>
      <TextField
        size="small"
        multiline
        minRows={2}
        maxRows={6}
        value={draft}
        onChange={(e) => setDraft(e.target.value.slice(0, MAX_LENGTH))}
        placeholder={placeholder}
        autoFocus={autoFocus}
        helperText={`${draft.length}/${MAX_LENGTH}`}
        FormHelperTextProps={{ sx: { textAlign: "right", m: 0 } }}
      />
      <Box display="flex" gap={1} justifyContent="flex-end">
        <Button size="small" onClick={onCancel} disabled={submitting}>
          Cancel
        </Button>
        <Button
          size="small"
          variant="contained"
          onClick={handleSubmit}
          disabled={disabled}
        >
          Reply
        </Button>
      </Box>
    </Stack>
  );
}
